import React from 'react';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export function IbanDialog() {
    const {onClose} = RsnDialog.useControls();
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader
                text='Virtual IBAN is being allocated'
                icon={{element: <RsnDialog.StatusIcon status={'progress'} />}}
            />
            <RsnDialog.Body>
                <p>To use EU bank transfers, wait for an email confirming IBAN allocation or choose another one.</p>
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Secondary onClick={onClose}>I got it</RsnButton.Secondary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
